import { queryOptions, UseMutationOptions } from "@tanstack/react-query";
import instance from "./axiosInstance";
import { Facility } from "types/facility.type";
import { TCreateFacility } from "pages/app/customer/AddFacility/createFacilitySchema";
import { TPatchFacility } from "pages/app/customer/AddFacility/patchFacilitySchema";

const FACILITY_ENDPOINT = "/facility";

export enum FacilityQueryKey {
  GetOne = "get-facility",
}

export const getFacility = (id: number) =>
  queryOptions({
    queryKey: [FacilityQueryKey.GetOne, id],
    queryFn: async (): Promise<Facility> =>
      (await instance.get(`${FACILITY_ENDPOINT}/${id}`)).data,
  });

export const createFacility = () => ({
  mutationFn: async (dto: TCreateFacility): Promise<Facility> =>
    (await instance.post(FACILITY_ENDPOINT, dto)).data,
});

export const patchFacility = (id: number) => ({
  mutationFn: async (dto: Partial<TPatchFacility>): Promise<Facility> =>
    (await instance.put(`${FACILITY_ENDPOINT}/${id}`, dto)).data,
});

export const deleteFacility = () => ({
  mutationFn: async (id: number): Promise<void> =>
    (await instance.delete(`${FACILITY_ENDPOINT}/${id}`)).data,
});
